/* eslint-disable max-len */
import React, {useRef, useState} from 'react';
import clsx from 'clsx';

import {Typography} from '@nur-portal/ui-kit';

import useOnClickOutside from '../../../website-ui/hooks/use-click-outside';

import styles from './index.module.css';

const Tooltip = ({leftAlignment}) => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipContentRef = useRef();
  const containerRef = useRef();
  const setTooltipOpen = () => {
    setIsOpen(true);
    containerRef.current?.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
  };
  const setToolTipClose = () => setIsOpen(false);

  useOnClickOutside(tooltipContentRef, setToolTipClose);

  return (
    <div className={styles.wrapper} ref={containerRef}>
      <Typography variant='title-14' className={styles.tooltipButton} component='button' onClick={setTooltipOpen}>
        Зачем
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          { /* eslint-disable-next-line max-len */ }
          <path fillRule="evenodd" clipRule="evenodd" d="M10.005 18.3399C14.6083 18.3399 18.34 14.6082 18.34 10.0049C18.34 5.40163 14.6083 1.66992 10.005 1.66992C5.40175 1.66992 1.67004 5.40163 1.67004 10.0049C1.67004 14.6082 5.40175 18.3399 10.005 18.3399ZM9.08201 11.6369H10.5349C10.5387 11.3444 10.5786 11.0918 10.6546 10.8791C10.7344 10.6664 10.8825 10.4632 11.099 10.2695C11.3497 10.034 11.5795 9.80604 11.7884 9.58573C11.9974 9.36542 12.1664 9.12801 12.2955 8.87351C12.4247 8.61521 12.4893 8.32083 12.4893 7.99036C12.4893 7.51555 12.3886 7.11291 12.1873 6.78244C11.986 6.44817 11.6954 6.19557 11.3155 6.02463C10.9357 5.8499 10.4799 5.76254 9.94807 5.76254C9.46566 5.76254 9.03073 5.8461 8.64328 6.01324C8.25583 6.17657 7.94626 6.42917 7.71455 6.77104C7.48664 7.10911 7.36698 7.53834 7.35559 8.05873H9.00794C9.01174 7.82323 9.05732 7.6333 9.14468 7.48896C9.23585 7.34461 9.3517 7.23826 9.49225 7.16988C9.63279 7.09771 9.78473 7.06163 9.94807 7.06163C10.1456 7.06163 10.3089 7.09961 10.4381 7.17558C10.571 7.25155 10.6698 7.36361 10.7344 7.51175C10.8027 7.65609 10.8369 7.83842 10.8369 8.05873C10.8369 8.24866 10.7989 8.42149 10.723 8.57723C10.647 8.72917 10.5425 8.87731 10.4096 9.02165C10.2766 9.166 10.1209 9.31794 9.94237 9.47747C9.72965 9.675 9.55872 9.87442 9.42957 10.0757C9.30422 10.2771 9.21496 10.5031 9.16178 10.7538C9.1124 11.0007 9.08581 11.2951 9.08201 11.6369ZM9.16178 12.7936C8.99464 12.9531 8.91108 13.1544 8.91108 13.3975C8.91108 13.633 8.99464 13.8325 9.16178 13.9958C9.32891 14.1591 9.55302 14.2408 9.83411 14.2408C10.1114 14.2408 10.3336 14.1591 10.5007 13.9958C10.6717 13.8325 10.7571 13.633 10.7571 13.3975C10.7571 13.1544 10.6717 12.9531 10.5007 12.7936C10.3336 12.6302 10.1114 12.5486 9.83411 12.5486C9.55302 12.5486 9.32891 12.6302 9.16178 12.7936Z" fill="#1E54B7" />
        </svg>
      </Typography>
      {isOpen && (
        <div className={clsx(styles.contentWrapper, {[styles.leftAlignment]: leftAlignment})} ref={tooltipContentRef}>
          <button
            className={styles.closeButton}
            onClick={setToolTipClose}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M16.192 6.34375L11.949 10.5858L7.70697 6.34375L6.29297 7.75775L10.535 11.9998L6.29297 16.2418L7.70697 17.6558L11.949 13.4137L16.192 17.6558L17.606 16.2418L13.364 11.9998L17.606 7.75775L16.192 6.34375Z" fill="#212121" />
            </svg>
          </button>
          <Typography variant='text-14' className={styles.content}>
            { /* eslint-disable-next-line max-len */ }
            Для участия в голосовании на NUR.KZ требуется активный аккаунт и подтверждение казахстанского номера телефона. Это условие нужно для обеспечения безопасности и предотвращения манипуляций с голосами.
          </Typography>
        </div>
      )}
    </div>
  );
};

export {Tooltip};
